import { Container, Heading } from '@amelio/ui-library';

import type { ReviewTypeValue } from '@/constants/review/CycleInstance';

import { useAmelioTranslations } from '@/hooks';
import { isSelfEvaluationReviewType } from '@/utils/cycleInstance';

interface EmptyResultsProps {
    reviewType: ReviewTypeValue;
    employeeFirstName: string;
}

export const EmptyResults = ({ reviewType, employeeFirstName }: EmptyResultsProps) => {
    const { t } = useAmelioTranslations();

    const getMessage = () => {
        // A self-assessment has one respondent, the employee; nobody else is waited on.
        if (!isSelfEvaluationReviewType(reviewType)) {
            return t('errors.noReviewerResponses');
        }

        if (!employeeFirstName) {
            return t('results.selfEvaluationPendingUnnamed');
        }

        return t('results.selfEvaluationPending', { firstName: employeeFirstName });
    };

    return (
        <Container
            px={'lg'}
            className={'mt-60 flex items-center justify-center'}
        >
            <Heading
                level={1}
                align={'center'}
            >
                {getMessage()}
            </Heading>
        </Container>
    );
};
